import { render, staticRenderFns } from "./storyPart.vue?vue&type=template&id=5071c88d&scoped=true"
import script from "./storyPart.vue?vue&type=script&lang=js"
export * from "./storyPart.vue?vue&type=script&lang=js"
import style0 from "./storyPart.vue?vue&type=style&index=0&id=5071c88d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5071c88d",
  null
  
)

export default component.exports